import MonacoEditor from "@monaco-editor/react";
import { useKernel } from "@/kernel/useKernel";
import { registerPythonProviders } from "@/kernel/monacoPython";

interface Props {
  value: string;
  onChange: (value: string) => void;
  readOnly?: boolean;
  height?: string;
  language?: string;
  theme?: "vs" | "vs-dark";
  fontSize?: number;
}

export default function Editor({
  value,
  onChange,
  readOnly = false,
  height = "100%",
  language = "python",
  theme = "vs-dark",
  fontSize = 14,
}: Props) {
  const kernel = useKernel();
  return (
    <MonacoEditor
      height={height}
      language={language}
      theme={theme}
      value={value}
      onMount={(_editor, monaco) => registerPythonProviders(monaco, kernel)}
      options={{
        fontSize,
        minimap: { enabled: false },
        scrollBeyondLastLine: false,
        readOnly,
        automaticLayout: true,
        tabSize: 4,
        insertSpaces: true,
        renderLineHighlight: "line",
        wordWrap: "on",
        suggest: { showKeywords: true },
      }}
      onChange={(v) => onChange(v ?? "")}
    />
  );
}
